import ReactDOM from "react-dom";
import { useContext } from "react";
import ThemeContext from "../../Contexts/themeContext";

const Portal = ({ id = "portal-root", children }) => {
  const { fullScreenStatus } = useContext(ThemeContext);

  const mount = document.getElementById(id);
  if (fullScreenStatus) return children;
  if (mount) return ReactDOM.createPortal(children, mount);
  return null;
};

export default Portal;
